import { useEffect, useState } from 'react';
import './Contact.scss';

const contactOptions = [
  'Ofereça espaço físico<br />para as nossas aulas',
  'Indique alunos<br />para aprender',
  'Patrocine um<br />dos nossos projetos',
  'Contrate nossos<br />alunos',
];

const SLACK_WEBHOOK_URL = 'https://hooks.slack.com/services/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';

const Contact = ({ hideTitle, removeMargin }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState('');

  useEffect(() => {
    if (submitStatus) {
      const timer = setTimeout(() => {
        setSubmitStatus('');
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [submitStatus]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('');

    try {
      const slackMessage = {
        text: `Nova mensagem do formulário de contato - ${formData.name}`,
        blocks: [
          {
            type: "section",
            text: {
              type: "mrkdwn",
              text: "*Nova mensagem do formulário de contato*"
            }
          },
          {
            type: "section",
            fields: [
              {
                type: "mrkdwn",
                text: `*Nome:*\n${formData.name}`
              },
              {
                type: "mrkdwn",
                text: `*E-mail:*\n${formData.email}`
              }
            ]
          },
          {
            type: "section",
            text: {
              type: "mrkdwn",
              text: `*Mensagem:*\n${formData.message}`
            }
          }
        ]
      };

      const [response] = await Promise.all([
        fetch(SLACK_WEBHOOK_URL, {
          method: 'POST',
          mode: 'no-cors',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(slackMessage)
        }),
        new Promise(resolve => setTimeout(resolve, 1000))
      ]);

      if (response.type === 'opaque') {
        setSubmitStatus('success');
        setFormData({ name: '', email: '', message: '' });
      } else if (response.ok) {
        setSubmitStatus('success');
        setFormData({ name: '', email: '', message: '' });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };
  return (
    <div className={`contact${removeMargin ? ' contact--no-margin' : ''}`}>
      {!hideTitle && <div className="contact__title">+Some com a gente!</div>}
      <div className="contact__container">
        <div className="contact__content">
          <div className="contact__options">
            {contactOptions.map((option, idx) => (
              <div className="contact__option" key={idx}>
                <span dangerouslySetInnerHTML={{ __html: option }} />
              </div>
            ))}
          </div>
          <form className="contact__form" onSubmit={handleSubmit}>
            <input
              className="contact__input"
              type="text"
              name="name"
              placeholder="NOME COMPLETO"
              value={formData.name}
              onChange={handleInputChange}
              disabled={isSubmitting}
              required
            />
            <input
              className="contact__input"
              type="email"
              name="email"
              placeholder="E-MAIL"
              value={formData.email}
              onChange={handleInputChange}
              disabled={isSubmitting}
              required
            />
            <textarea
              className="contact__textarea"
              name="message"
              placeholder="MENSAGEM"
              value={formData.message}
              onChange={handleInputChange}
              disabled={isSubmitting}
              required
            />
            <button
              className="contact__button"
              type="submit"
              disabled={isSubmitting}
            >
              {isSubmitting && <div className="contact__loading-spinner"></div>}
              {isSubmitting ? 'ENVIANDO...' : 'ENVIAR'}
            </button>
            {submitStatus === 'success' && (
              <div className="contact__success-message">
                <div className="contact__message-icon">✅</div>
                <div>
                  <strong>Mensagem enviada com sucesso!</strong>
                  <br />
                  <small>Recebemos sua mensagem e entraremos em contato em breve.</small>
                </div>
              </div>
            )}
            {submitStatus === 'error' && (
              <div className="contact__error-message">
                <div className="contact__message-icon">❌</div>
                <div>
                  <strong>Erro ao enviar mensagem.</strong>
                  <br />
                  <small>Verifique sua conexão com a internet e tente novamente.</small>
                </div>
              </div>
            )}
          </form>
        </div>
      </div>
    </div>
  )
}

export default Contact
